import React from 'react'
export const Context = React.createContext<{ clientId: any }>({ clientId: 0 })
